module.exports = __webpack_public_path__ + "static/template_options_3_years-3c74adb2381fac255d2688ebb508363d.png";